import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { PershingResponsiveComponent } from '@pershing/pershing-common';

@Component({
    styles: [`
        .trading-responsive: {
            box-sizing: border-box;
            width: 100%;
        }
    `],
    selector: 'trading-responsive',
    templateUrl: './trading-responsive.component.html'
})
export class TradingResponsiveComponent extends PershingResponsiveComponent implements OnInit {

    @Input()
    respondToWindow: boolean;

    @Input()
    small: TemplateRef<Object>;

    @Input()
    medium: TemplateRef<Object>;

    @Input()
    large: TemplateRef<Object>;

    constructor() {
        super();
    };

    ngOnInit() {
        if (this.respondToWindow) {
            this.pershingResponsiveWindow = null;
        } else {
            this.pershingResponsiveWindow = new Date().getMilliseconds().toString() + Math.random();
        }
        this.sizeConfig = {
            small: { sizes: { window: this.pershingResponsiveWindow, min: 0, max: 768 } },
            medium: { sizes: { window: this.pershingResponsiveWindow, min: 768, max: 1024 } },
            large: { sizes: { window: this.pershingResponsiveWindow, min: 1024, max: 9999 } }
        };
    };
}
